import React, { useEffect, useState } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { Layout } from "../../containers";
import { Container } from "./styled";
import secureLocalStorage from "react-secure-storage";
import { parseClipSlug } from "../../lib/cliSlug";
import firebase from "../../lib/fire";

function SharedBoard() {
  const { id } = useParams();
  const [clipData, setClipData] = useState(null);
  const [loading, setLoading] = useState(true);
  const history = useHistory();
  const location = useLocation();
  const userId = secureLocalStorage.getItem("userId");
  const sessionUser = sessionStorage.getItem("user");
  const [authChecked, setAuthChecked] = useState(false);

  useEffect(() => {
    const unsubscribe = firebase.auth().onAuthStateChanged(async (user) => {
      if (!user) {
        secureLocalStorage.removeItem("userId");
        secureLocalStorage.removeItem("user");
        secureLocalStorage.removeItem("userLocal");
        sessionStorage.removeItem("user");

        history.replace("/app/login");
        return;
      }

      try {
        secureLocalStorage.setItem("userId", user.uid);
        sessionStorage.setItem("userAuth", true);

        const snapshot = await firebase
          .database()
          .ref(`/users/0/${user.uid}`)
          .once("value");

        const userData = snapshot.val() || {};
        sessionStorage.setItem("user", JSON.stringify(userData));
        secureLocalStorage.setItem("user", userData);
        setAuthChecked(true);
      } catch (error) {
        console.error("❌ Error al sincronizar usuario:", error);
      }
    });

    return () => unsubscribe();
  }, [history, location.pathname]);

  useEffect(() => {
    async function handleSharedClip(slug) {
      try {
        const isCollection = slug.startsWith("CO-");
        const userData = JSON.parse(sessionUser);
        const currentUser = firebase.auth().currentUser;
        if (!currentUser) return;

        const receiverUid = currentUser.uid;

        if (isCollection) {
          const { senderId, collectionId } = parseCollectionSlug(slug);

          const sharedWithMeRef = firebase
            .database()
            .ref(`/users/0/${receiverUid}/sharedCollections/${collectionId}`);

          await sharedWithMeRef.set({
            collectionId,
            senderId,
            sharedAt: new Date().toISOString(),
          });
          let collectionData = {
            collectionId,
            senderId,
            sharedAt: new Date().toISOString(),
          };
          await firebase
            .database()
            .ref(`/users/0/${receiverUid}/relatedAccounts/${senderId}`)
            .set(true);

          let sharedCollectionsBkp = userData.sharedCollections || {};
          sharedCollectionsBkp[collectionId] = {
            ...collectionData,
            senderId,
          };

          userData.sharedCollections = sharedCollectionsBkp;

          await sessionStorage.setItem("user", JSON.stringify(userData));
          secureLocalStorage.setItem("user", userData);
          secureLocalStorage.setItem("userLocal", userData);

          history.push(`/app/analytics-dashboard/sharedCollections`);
        } else {
          const { senderId, clipId, templateId } = parseClipSlug(slug);

          const sharedWithMeRef = firebase
            .database()
            .ref(`/users/0/${receiverUid}/sharedWithMe/${clipId}`);
          await sharedWithMeRef.set({
            clipId,
            senderId,
            templateId,
            sharedAt: new Date().toISOString(),
          });

          const relatedAccountsRef = firebase
            .database()
            .ref(`/users/0/${receiverUid}/relatedAccounts/${senderId}`);
          await relatedAccountsRef.set(true);

          const response = await fetch(
            "https://deportactico-vercel-serverless.vercel.app/api/getSharedClipsWithBoards",
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ userId }),
            }
          );
          const data = await response.json();
          const activeClip = data.sharedClips.filter((d) => d.id === clipId);

          if (activeClip.length > 0) {
            let sharedBoardsBkp = userData.sharedWithMe || {};
            sharedBoardsBkp[clipId] = {
              clipId: clipId,
              senderId,
              templateId,
            };
            userData.sharedClips = sharedBoardsBkp;
            await sessionStorage.setItem("user", JSON.stringify(userData));
            secureLocalStorage.setItem("user", userData);
            secureLocalStorage.setItem("userLocal", userData);
            setClipData({
              id: clipId,
              senderId,
              templateId,
              ...activeClip[0],
            });
            history.push(`/app/analytics-dashboard/sharedClips`);
          } else {
            setClipData(null);
          }
        }
      } catch (err) {
        console.error("❌ Error compartiendo clip:", err);
        setClipData(null);
      } finally {
        setLoading(false);
      }
    }

    if (id && authChecked) handleSharedClip(id);
  }, [id, authChecked]);

  function parseCollectionSlug(slug) {
    const parts = slug.replace("CO-", "").split("__");
    const senderId = parts[0];
    const collectionId = parts[1];
    return { senderId, collectionId };
  }

  if (!userId) {
    history.push("/app/login", { from: location.pathname });
    return null;
  }

  if (loading) return <p>Loading shared clip...</p>;

  return (
    <Layout>
      <Container>
        {clipData ? (
          <div style={{ padding: "20px" }}>
            <h2 style={{ marginBottom: "10px" }}>
              📊 {clipData.name || "Clip compartido"}
            </h2>
            <p>
              <strong>Compartido por:</strong> {clipData.senderId}
            </p>
            <p>
              <strong>Template:</strong> {clipData.templateId}
            </p>
            <p>
              <strong>Fecha:</strong>{" "}
              {new Date(clipData.sharedAt || Date.now()).toLocaleString()}
            </p>

            <div
              style={{
                marginTop: "20px",
                background: "#f8f8f8",
                padding: "15px",
                borderRadius: "8px",
                fontFamily: "monospace",
                whiteSpace: "pre-wrap",
              }}
            >
              {JSON.stringify(clipData.config, null, 2)}
            </div>
          </div>
        ) : (
          <p>❌ Clip no encontrado o ya fue eliminado.</p>
        )}
      </Container>
    </Layout>
  );
}

export default SharedBoard;
